import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          漫画特辑
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 cursor-pointer">
                    <i className="ri-play-fill text-sm"></i>
                  </span>
                  <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-600 line-clamp-2">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}